import React from 'react';
import { Popover, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface popText {
  summary: string;
  content: string;
}

function getHelpText(summary: string, content: string) {
  return (
    <div style={{ maxWidth: 700, padding: 8 }}>
      <Text strong style={{ display: 'block', marginBottom: 8 }}>
        {summary}
      </Text>
      <Text style={{ fontSize: 14, lineHeight: 1.5 }}>{content}</Text>
    </div>
  );
}

const popOverMenu = (prop: popText) => {
  const { summary, content } = prop;
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Popover
        content={getHelpText(summary, content)}
        color="#e6f7ff"
        placement="bottomRight"
        overlayStyle={{
          maxWidth: 700,
          boxShadow:
            '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
        }}
        trigger="hover"
      >
        <InfoCircleOutlined style={{ fontSize: 16, color: '#999', cursor: 'pointer' }} />
      </Popover>
    </div>
  );
};

export default popOverMenu;
